<template>
  <RevButton
    v-if="buttonConfig"
    size="small"
    :variant="buttonConfig.variant"
    @click="handleClick"
  >
    {{ i18n(buttonConfig.label) }}
  </RevButton>
</template>

<script setup lang="ts">
import { useLogout } from '@backmarket/nuxt-layer-oauth/useLogout'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import { useAdminButton } from '~/scopes/navigation/composables/useAdminButton'

const i18n = useI18n()
const { logout } = useLogout()
const { buttonConfig } = useAdminButton()

async function handleClick() {
  if (buttonConfig.value) {
    await logout(buttonConfig.value.redirection)
  }
}
</script>
